import { CombinedGraphQLErrors } from "@apollo/client";
import { type FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTE_USERS } from "src/constants/route";
import { useAddUser } from "src/graphql";
import UserForm, { type UserData } from "./UserForm";

const AddUserComponent: FC = () => {
  const [queryError, setQueryError] = useState<string>();
  const navigate = useNavigate();
  const [insertUser] = useAddUser({
    onCompleted: () => {
      window.location.href = ROUTE_USERS;
    },
  });

  const doInsert = (userData: UserData) => {
    insertUser({ variables: { userData } })
      .then(() => navigate(ROUTE_USERS))
      .catch(
        (error: unknown) =>
          CombinedGraphQLErrors.is(error) && setQueryError(error.message),
      );
  };

  const emptyUser = {
    id: "",
    name: "",
    email: "",
    password: "",
    roles: [],
  };

  return (
    <div className="col-6">
      <h3>Add user</h3>
      <hr />
      <UserForm user={emptyUser} error={queryError} callback={doInsert} />
    </div>
  );
};

export default AddUserComponent;
